import { SafeSessionStorage } from './localStorage';

import * as Sentry from '@sentry/nextjs';

export const LEADER_REDIRECT_URL = 'LEADER_REDIRECT_URL';

const CRIBL_DOMAIN = process.env.SHARED_DOMAIN;

export const isValidLeaderUrl = (url: string): boolean => {
  try {
    const { hostname, protocol } = new URL(url);

    if (protocol === 'https:' && CRIBL_DOMAIN && hostname.endsWith(CRIBL_DOMAIN)) {
      return true;
    } else {
      return false;
    }
  } catch {
    return false;
  }
};

export const setLeaderRedirectUrl = (toRedirectUrl: string): void => {
  if (isValidLeaderUrl(toRedirectUrl)) {
    SafeSessionStorage.setItem(LEADER_REDIRECT_URL, toRedirectUrl);
  } else {
    let errorMessage = 'Invalid \'from\' query param';

    Sentry.captureException(errorMessage);
  }
};

export const setLeaderRedirectUrlFromQuery = (): void => {
  const queryString = window.location.search;
  const toRedirectUrl = new URLSearchParams(queryString).get('from');
  setLeaderRedirectUrl(toRedirectUrl as string);
};

export const getCleanLeaderRedirectUrl = (): string | null => {
  const toRedirectUrl = SafeSessionStorage.getItem(LEADER_REDIRECT_URL);
  SafeSessionStorage.removeItem(LEADER_REDIRECT_URL);

  return toRedirectUrl;
};
